export default "__VITE_ASSET__Cr3b8Zxh__"